export const ENV = import.meta.env.VITE_MODE;
export const API_URL = import.meta.env.VITE_WRASSETS_URL;
export const URL = import.meta.env.VITE_URL;
export const AUTH0_CLIENT_SECRET = import.meta.env.VITE_AUTH0_CLIENT_SECRET;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_INTERNAL_DOMAIN = import.meta.env.VITE_AUTH0_INTERNAL_DOMAIN;
export const AWSREGION = import.meta.env.VITE_AWSREGION;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;
export const STATE = import.meta.env.VITE_STATE;
export const V2_API_URL = import.meta.env.VITE_V2_API_URL;
